import L from 'leaflet';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { TrialLocationView } from '@data/sdk/match';
import 'leaflet/dist/leaflet.css';

const CENTER = {
  lat: 0.0,
  long: 0.0,
};

const markerIcon = new L.Icon({
  iconUrl,
  iconRetinaUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

type MapProps = {
  locations: TrialLocationView[];
};
export const Map = ({ locations }: MapProps) => {
  return (
    <MapContainer
      attributionControl={false}
      center={[CENTER.lat, CENTER.long]}
      zoom={1}
      className="w-full h-72 rounded-lg"
      worldCopyJump
    >
      <TileLayer attribution="CureWiki" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {locations.map(
        ({ coordinates, id, city, country, facility, zip }) =>
          coordinates && (
            <Marker key={id} icon={markerIcon} position={[coordinates.lat, coordinates.long]}>
              <Popup>
                {facility}, {city}, {country}, {zip}
              </Popup>
            </Marker>
          ),
      )}
    </MapContainer>
  );
};
